import { WorkingShiftDateRange } from './working-shift-date-range';

export class WorkingShift {
  constructor(
    public hash?: string,
    public name?: string,
    public hasBreak?: boolean,
    public breakTime?: number,
    public workingShiftDateRanges?: WorkingShiftDateRange[]
  ) { }

  clone() {
    return new WorkingShift(
      this.hash,
      this.name,
      this.hasBreak,
      this.breakTime,
      this.workingShiftDateRanges
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/calendar/working-shift.ts